/**
 * Trusted-device list + revoke (Phase 1). Shared by both rails — endpoint is /api/v1/me/devices,
 * JWT-gated for any authenticated customer (FULL or vitrine). The device-identity cookie
 * (tacita_device) rides along automatically (withCredentials) so the backend can flag `current`.
 */
import { http } from './http';

export interface DeviceView {
  id: string;
  label: string | null;
  trusted: boolean;
  current: boolean;
  createdAt: string;
  lastSeenAt: string;
}

export const devicesApi = {
  list() {
    return http.get<DeviceView[]>('/v1/me/devices').then(r => r.data);
  },

  revoke(id: string) {
    return http.delete(`/v1/me/devices/${id}`);
  },
};
